




























import { Vue, Component, Emit, Prop } from "vue-property-decorator"
import { BaseUserInfo } from "@/types"
@Component({
    name: "UserMenu"
})
export default class UserMenu extends Vue {
    getPopupContainer() {
        return document.body
    }
    @Prop({
        type: Function,
        default: async () => ({
            avatar: "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
            name: "加载中"
        })
    })
    readonly getUserInfo!: Function

    // data
    baseInfo: BaseUserInfo = {
        avatar: "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
        name: "加载中"
    }

    @Emit()
    loginOut() {
        return this.baseInfo
    }

    @Emit()
    toPersonal() {
        return this.baseInfo
    }

    // hooks
    async created() {
        const baseInfo = await this.getUserInfo()
        this.baseInfo = baseInfo
    }
    // methods
    toHelp() {
        window.open(`https://doc.intsig.net/pages/viewpage.action?pageId=547422329`)
    }
}
